import ParagraphLight from "../UI/ParagraphLight";
import SectionHeader from "../UI/SectionHeader";
import AboutMe from "./AboutMe";

const AboutSection = props => {
    return (
        <div class='bg-black pb-32'>
            <section id='section-about'>
                <SectionHeader text={'About Me'} headerGradientStyle={'header-about-me'} />
                <AboutMe projectTitle={`Hi! 👋 I'm Marco`} bgImage={'bg-virus'} techStack={['HTML5', 'CSS3', 'GitHub', 'JS', 'React', 'Figma', 'Netlify', 'Linux']}>
                    <ParagraphLight>
                        I am a Software Engineer working on open source and enterprise mobile SDKs for iOS and macOS developers written in Swift.
                    </ParagraphLight>
                    <ParagraphLight>
                        2006 I finished my studies at the <a class='link link-primary' href='https://www.dhbw.de/english/home' target='_blank' rel='noreferrer'>Baden-Wuerttemberg Cooperative State University Mannheim (Germany)</a> for B.Sc. Business Information Systems. Due to the nature of this program, I was already an SAP employee at that time.
                    </ParagraphLight>
                    <ParagraphLight>
                        2011 was the year I started with mobile development. My previous roles in SAP were backend-focused.
                    </ParagraphLight>
                    <ParagraphLight>
                        In 2013 I moved to the United States. Nowadays, I am a permanent resident.
                    </ParagraphLight>
                </AboutMe>
            </section>
        </div>
    );
};

export default AboutSection;
